import {SpotPositionCode} from "@commons/constants";

export const SpotType = {
    Misc: 0,
    Html: 1,
    ProductList: 2,
    CategoryLink: 3,
    ProductSlider: 4,
    ImageSlider: 5
}

export type SpotTypeName = (typeof SpotType)[keyof typeof SpotType];

export type CategorySpot = {
    Id?: number;
    IndexNumber?: number;
    SpotType: SpotTypeName;
    PositionCode: SpotPositionCode;
    DataListId?: number;
    CategoryId?: number;
    CategoryDetailId?: number;
    DataListName?: string;
    Content?: string;
}

export type DeleteCategorySpotCommand = {
    Id: number;
    CategoryId: number;
    CountryId?: number;
    DataListId?: number
}

export type CreateCategorySpotCommand = {
    CategoryId: number;
    CategoryDetailId: number;
    SpotType: SpotTypeName;
    PositionCode: SpotPositionCode;
    DataListId?: number;
    Content?: string;
}